<template>
    <LayoutPage
        :title="title">

        <template v-slot:banner>
            <BannerSmallerWithSearchAndButton
                :imageName="$t('UI.banners.smallerBannerImage')"
                :title="data.title"
                :description="data.description"
            />
        </template>

        <template v-slot:content>
            <div class="mm-section">
                <div class="mm-section-content">
                    <div class="container-fluid w-100">
                        <div class="row">
                            <div class="col-12 box box--center box--space-vertical">
                                <span class="headline headline--second pt-5">
                                    {{data.timelineBanners.title}}
                                </span>

                                <span class="headline headline--fifth pt-4 pb-4">
                                    {{data.timelineBanners.description}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <TimelineBanner
                v-if="$te('gisCloudPage.timelineBanners.slots')"
                :timelineClassname="'mm-timeline--white'"
                :items="$t('gisCloudPage.timelineBanners.slots')" />

        </template>
    </LayoutPage>
</template>

<script>
import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'
import LayoutPage from '@/components/layouts/Page';
import BannerSmallerWithSearchAndButton from '@/components/ui/Banner/SmallerWithSearchAndButton';
import TimelineBanner from '@/components/ui/TimeLineBanner';

export default {
    components: {
        LayoutPage,
        BannerSmallerWithSearchAndButton,
        TimelineBanner
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));
    },
    data() {
        return {
            data: this.$t('gisCloudPage')
        };
    }
}
</script>
